import axios from './axios';

export default {
  list() {
    return axios.get('/conversations');
  },
  get(id) {
    return axios.get(`/conversations/${id}`);
  },
  postMessage(conversationId, formData) {
    return axios.post(`/conversations/${conversationId}/messages`, formData, { headers: { 'Content-Type': 'multipart/form-data' } });
  },
  create(adminUserId, formData) {
    return axios.post(`/admin_users/${adminUserId}/conversations`, formData, { headers: { 'Content-Type': 'multipart/form-data' } });
  },
};
